import React from 'react';
import ContactUsForm from '../../ContactPage/ContactUsForm';

function ContactForm(props) {
    return (
        <div className='mx-auto flex flex-col justify-center items-center mt-14 mb-20'>
            <h1 className='text-3xl text-richblack-25 font-semibold'>
                Get in Touch
            </h1>
            <p className='text-richblack-50 mt-2'>We’d love to here for you, Please fill out this form.</p>
            <div className='mt-20 max-[450px]:w-[80%]'>
                <ContactUsForm/>
            </div>
        </div>
    );
}

export default ContactForm;